var Layout         = require("enyo-ui/Layout"),
    dom            = require("enyo/dom"),
    kind           = require("enyo/kind"),
    appThemeVars   = require("app/theme/variables.js"),
    PopupVariables = require("app/theme/styles/MediaDetailPopupVariables");

/**
 * This layout is meant specifically for the MediaDetailsPopup.
 */
module.exports = kind(/** @lends  app.AppLayout.MediaDetailsPopupLayout.prototype */ {

    /**
     * @private
     */
    name: "app.AppLayout.MediaDetailsPopupLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        if (appThemeVars.windowWidth < PopupVariables.getLayoutBreakpointPx()) {
            this.pageLayout();
        }
        else {
            this.popupLayout();
        }
    },

    /**
     * @private
     */
    pageLayout: function() {
        var $container          = this.container,
            $appView            = $container.app.view,
            contentRegionBounds = $appView.get("contentRegionBounds") || {},
            popupWidth,
            popupHeight,
            $scrollerDecorator  = $container.$.scrollerDecorator,
            $scroller           = $container.$.scroller,
            $client             = $container.$.client;

        if (!$appView.hasNode() || !$container.hasNode()) {
            return;
        }

        popupWidth  = contentRegionBounds.width || 0;
        popupHeight = contentRegionBounds.height || 0;

        dom.transformValue($container, "translate", "0, 0");
        $container.setBounds({
            top:    "0px",
            left:   "0px",
            width:  popupWidth + "px",
            height: popupHeight + "px"
        });
        $container.applyStyle("max-height", null);

        $scrollerDecorator.set("fit", true);

        $scroller.set("width", null);
        $scroller.set("maxHeight", null);
        $scroller.set("fit", true);
        $client.set("fit", true);

        // Broadcast metrics
        // --------------------------------

        // Report layoutMetrics for other components to use
        $container.set("layoutMetrics", {
            popupWidth:  popupWidth,
            popupHeight: popupHeight
        });
    },

    /**
     * @private
     */
    popupLayout: function() {
        var $container          = this.container,
            $appView            = $container.app.view,
            headerRegionBounds  = $appView.get("headerRegionBounds") || {},
            contentRegionBounds = $appView.get("contentRegionBounds") || {},
            offsetTop,
            popupMaxHeight,
            popupWidth,
            $scrollerDecorator  = $container.$.scrollerDecorator,
            $scroller           = $container.$.scroller,
            $client             = $container.$.client;

        if (!$appView.hasNode() || !$container.hasNode()) {
            return;
        }

        offsetTop      = (headerRegionBounds.height || 0) + (appThemeVars.getContentPaddingVerticalPx() * 2);
        popupMaxHeight = (contentRegionBounds.height || 0) - (appThemeVars.getContentPaddingVerticalPx() * 4);

        if (appThemeVars.appHeaderFloat === true) {
            popupMaxHeight -= headerRegionBounds.height || 0;
        }
        popupWidth = (contentRegionBounds.width || 0)
            - Math.max(appThemeVars.safeAreaInsetLeft, appThemeVars.getPageMarginLargePx())
            - Math.max(appThemeVars.safeAreaInsetRight, appThemeVars.getPageMarginLargePx());
        popupWidth = Math.min(
            PopupVariables.getMaxPopupWidth($container.get("formFactor")),
            popupWidth
        );

        dom.transformValue($container, "translate", "-50%, 0");
        $container.setBounds({
            top:    offsetTop + "px",
            left:   "50%",
            width:  popupWidth + "px",
            height: "auto"
        });
        $container.applyStyle("max-height", popupMaxHeight + "px");

        $scrollerDecorator.set("fit", false);
        $scroller.set("width", "100%");
        $scroller.set("maxHeight", popupMaxHeight + "px");
        $scroller.set("fit", false);
        $client.set("fit", false);

        // Broadcast metrics
        // --------------------------------

        // Report layoutMetrics for other components to use
        $container.set("layoutMetrics", {
            popupWidth:     popupWidth,
            popupMaxHeight: popupMaxHeight
        });
    }

});
